// extracted by mini-css-extract-plugin
module.exports = {"content":"Home_content__2Q55q","content--loading":"Home_content--loading__1nnvB"};